import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";

export function ParseInputJSON(
    unparsedJSON: string,
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>,
    state: IRootNodeFormState,
    setIsValidJSON: React.Dispatch<React.SetStateAction<boolean>>
) {
    React.useEffect(() => {
        try {
            var parsedJSON = JSON.parse(unparsedJSON);

            setState({
                ...state,
                newOptions: parsedJSON,
            });

            setIsValidJSON(true);
        } catch (error) {
            setIsValidJSON(false);
        }
    }, [unparsedJSON]);
}
